<template>
  <div class="grid place-items-center min-h-screen">
    <slot />
  </div>
</template>
